import React from 'react';
import PropTypes from 'prop-types';

// INPUT
import TextFieldGroup from '../../../../../components/common/textFieldGroup/TextFieldGroup';

// VALIDATIONS
import isEmptyVAL from '../../../../../validations/checks/isEmptyVAL';

// UTILITIES
import { outputMasterUTL } from '../../../../../utils/outputMasterUTL';
import { transUTL } from '../../../../../utils/transUTL';

const ContactDetailsNewZealand = ({
  formState,
  selectedDataSources,
  handleOnChange,
  handleOnBlur,
  handleEnterKeyTrigger,
}) => {
  const { phoneNo, landlineNo, errors } = formState;

  const inputElements = [
    {
      belongsTo: [
        'New Zealand Companies Office',
        'New Zealand Residential',
        'New Zealand LINZ Property',
      ],
      element: (
        <TextFieldGroup
          key="phoneNo"
          id="phoneNo"
          type="text"
          name="phoneNo"
          dataName="phoneNoNZ"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.phoneNo')}
          value={phoneNo}
          placeholder={transUTL('translatePlaceholder.inputNZ.phoneNo')}
          placeholderTrigger={isEmptyVAL(phoneNo) ? 'input-empty' : ''}
          error={errors.phoneNo}
          errorTrigger={errors.phoneNo ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
    {
      belongsTo: [
        'New Zealand Companies Office',
        'New Zealand Residential',
        'New Zealand LINZ Property',
      ],
      element: (
        <TextFieldGroup
          key="landlineNo"
          id="landlineNo"
          type="text"
          name="landlineNo"
          dataName="landlineNoNZ"
          labelClass="form-group__label"
          label={transUTL('translateFormOverview.inputLabels.landlineNo')}
          value={landlineNo}
          placeholder={transUTL('translatePlaceholder.inputNZ.landlineNo')}
          placeholderTrigger={isEmptyVAL(landlineNo) ? 'input-empty' : ''}
          error={errors.landlineNo}
          errorTrigger={errors.landlineNo ? 'input-error' : ''}
          handleOnChange={handleOnChange}
          handleOnBlur={handleOnBlur}
          handleEnterKeyTrigger={handleEnterKeyTrigger}
        />
      ),
    },
  ];

  return (
    <div className="form-overview__form-inputs">
      {outputMasterUTL(selectedDataSources, inputElements)}
      <span />
    </div>
  );
};

ContactDetailsNewZealand.propTypes = {
  formState: PropTypes.object.isRequired,
  selectedDataSources: PropTypes.array.isRequired,
  handleOnChange: PropTypes.func.isRequired,
  handleOnBlur: PropTypes.func.isRequired,
  handleEnterKeyTrigger: PropTypes.func.isRequired,
};

export default ContactDetailsNewZealand;
